export const gameLink = {
  name: 'slotGameLink',
  path: '/slot/game',
  component: () => import('@/components/common/SlotsGameLink'),
  meta: {
    layout: 'empty',
    gnbSub: false
  }
}
